import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Address} from '../../class/address';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {

  @Input()
  addresses: Address[];
  @Input()
  editMode: boolean;

  @Output()
  onAddressAdded = new EventEmitter<Address[]>();
  constructor() { }

  ngOnInit(): void {
    this.initAddress();
  }

  addRow(){
    this.initAddress();
    this.addresses.push({
      address: null,
      cap: null,
      city: null,
      local: null,
      nation: null,
      state: null
    });
    this.onAddressAdded.emit(this.addresses);
  }

  private initAddress(){
    if(!this.addresses){
      this.addresses = [];
    }
  }

}
